import { Box, Button, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IoMdLogOut } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { actionLogout } from '../../../api/postApi';
import UserLogout from '../../../api/UserLogout';
import { notice } from '../../../redux/action/action';
import { clearFavoriteGameList } from '../../../redux/action/game/gameAction';
import {
  cleanMemberInfo,
  clearTransferWallet
} from '../../../redux/action/member/memberAction';
import { COMMON_WEB_PATH } from '@/constant';
import i18next from 'i18next';

const useLogoutButton = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleLogoutUser = () => {
    actionLogout().then((data) => {
      dispatch(
        notice({
          title: i18n('Logout Success'),
          type: 'success'
        })
      );
      window?.google?.accounts?.id.disableAutoSelect();
      UserLogout();
      dispatch(cleanMemberInfo());
      dispatch(clearFavoriteGameList());
      dispatch(clearTransferWallet());
      navigate('/signin');
    });
  };

  return {
    asideLogoutBtn: (
      <Box
        onClick={handleLogoutUser}
        minH="50px"
        w="140px"
        m="auto"
        bgSize={'100% 100%'}
        bgRepeat="no-repeat"
        display="flex"
        alignItems={`center`}
        justifyContent={`center`}
        cursor={`pointer`}
        bgImage={`url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/logout_button.png)`}
      ></Box>
    ),
    profileCardLogoutBtn: (
      <Button
        bg="brand.500"
        _hover={{
          bg: 'brand.500'
        }}
        onClick={handleLogoutUser}
        color="white"
        fontSize="lg"
        aria-label="Logout"
        rightIcon={<IoMdLogOut />}
      >
        {i18n('logout')}
      </Button>
    )
  };
};

export default useLogoutButton;
